import { all } from 'redux-saga/effects';

import list from './fetchParcels';
import cancelDelivery from './cancelParcelDelivery';

export default function* jobs() {
    yield all([list(), cancelDelivery()]);
}
